import type { HTMLAttributes } from 'react';

import React from 'react';

import { classNames } from '../../utils/class-names';

import styles from './typography.module.css';

export const Heading = ({ children, className, ...props }: HTMLAttributes<HTMLHeadingElement>) => (
  <h1 className={classNames(styles.heading, className)} {...props}>
    {children}
  </h1>
);

export const SubHeading = ({ children, className, ...props }: HTMLAttributes<HTMLHeadingElement>) => (
  <h2 className={classNames(styles.subheading, className)} {...props}>
    {children}
  </h2>
);

export const Paragraph = ({ children, className, ...props }: HTMLAttributes<HTMLParagraphElement>) => (
  <p className={classNames(styles.paragraph, className)} {...props}>
    {children}
  </p>
);
